export default __webpack_public_path__ + "2f1ad82e2d6bc207b9ac3a52fdf2c3dd.svg";